"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importDefault(require("styled-components"));
var Text_1 = __importStar(require("../components/Text"));
var ATag = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Link = function (props) {
    var to = props.to, replace = props.replace, innerRef = props.innerRef, children = props.children, _a = props.asText, asText = _a === void 0 ? true : _a, targetBlank = props.targetBlank, rest = __rest(props, ["to", "replace", "innerRef", "children", "asText", "targetBlank"]);
    if (typeof to === "string" && (targetBlank || to.startsWith("http"))) {
        var passedProps = __assign({ tag: "a", href: to, target: "_blank", rel: "noopener noreferrer", children: children }, rest);
        var Comp = asText ? Text_1.default : ATag;
        return react_1.default.createElement(Comp, __assign({}, passedProps));
    }
    else {
        var passedProps = __assign(__assign({}, rest), { to: to, replace: replace, innerRef: innerRef, children: children });
        var Comp = asText ? Text_1.TextLink : react_router_dom_1.Link;
        return react_1.default.createElement(Comp, __assign({}, passedProps));
    }
};
exports.default = Link;
var templateObject_1;
